import React from 'react';
import MapFallback from './MapFallback';

interface GoogleMapProps {
  className?: string;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ className = '' }) => {
  // Use fallback by default for reliability
  // Google Maps has been causing too many issues on mobile devices
  return <MapFallback className={className} />;
};

export default GoogleMap;
